/**
 * @desc 效验订单发货信息地址1或地址2或州是否包含拦截地区
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrder.checkOrderShippingAddress.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrder/checkOrderShippingAddress`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
